import CustomIcon from "../CustomIcon/CustomIcon";
import * as Styles from "./StatusGroupCard.styles";
import LabelImportantRoundedIcon from "@mui/icons-material/LabelImportantRounded";

interface StatusGroupCardProps {
  title: string;
  children: React.ReactNode;
}

export default function StatusGroupCard({ title, children }: StatusGroupCardProps) {
  return (
    <div>
      <Styles.CardHeaderContainer>
        <Styles.CardHeaderContent>
          <CustomIcon Icon={LabelImportantRoundedIcon} color="var(--color-primary)" />
          {title}
        </Styles.CardHeaderContent>
      </Styles.CardHeaderContainer>

      <Styles.CardBody>{children}</Styles.CardBody>
    </div>
  );
}
